import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { helpCenterActions } from 'state/helpRequest/actions';
import type { ThunkDispatch } from 'state/state.common';

interface OwnProps {
  helpCenterId: string;
  defaultMessage?: string;
}
interface StateProps {
  'ISIN Code'?: string;
  'File Code'?: string;
  'Product key'?: string;
  'External quote id'?: string;
  'Order id'?: string;
  'Pricer id'?: string;
  'Product id'?: string;
  'Quote id'?: string;
  'Trade id'?: string;
}
interface DispatchProps {
  onOpenHelpRequest: (text?: string) => void;
}
const mapDispatchToProps = (dispatch: ThunkDispatch, { helpCenterId }: OwnProps): DispatchProps => ({
  onOpenHelpRequest(text) {
    dispatch(helpCenterActions.open(helpCenterId, { messageTemplate: text }));
  },
});

interface Props extends OwnProps, DispatchProps, StateProps {}
export const ConnectedHelpCenterButton = connect(undefined, mapDispatchToProps)(HelpCenterButton);
function HelpCenterButton({ onOpenHelpRequest, defaultMessage }: Props) {
  return (
    <button
      type="button"
      className="btn btn-discreet-secondary w-100 "
      onClick={() => onOpenHelpRequest(defaultMessage)}
    >
      <FormattedMessage id="lifeRing.helpRequest" />
      <em className="icon icon-outlined ms-1">live_help</em>
    </button>
  );
}
